<template>
  <div class="apply-area flex-r-center">
    <div class="card-width">
      <el-card>
        <div slot="header" class="card-wrap flex-center-center fz24">
          申领个人电子私章
        </div>
        <div class="content" v-loading="loading">
          <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="120px"
              class="demo-ruleForm"
          >
            <div class="top-area">
              <div class="area-title">个人私章样式</div>
              <div class="seal-confirm">
                <div class="confirm-text fz14 fc3">私章确认：</div>
                <div class="image-div">
                  <el-button size="mini" type="primary" @click="getHandPad">
                    我要手写
                  </el-button>
                  <div class="image-seal">
                    <img :src="personImg"/>
                    <el-button v-if="qrImg" size="small" class="img-del-btn" type="danger" @click="handleDelImg"
                               icon="el-icon-delete" circle></el-button>
                  </div>
                </div>
              </div>
              <div class="area-title">基本信息</div>
              <el-row>
                <el-col :span="24">
                  <el-form-item prop="sealName" class="pass-form" label="印章名称">
                    <el-input
                        v-model="ruleForm.sealName"
                        placeholder="请输入印章名称"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item prop="sealWidth" class="pass-form" label="印章宽度">
                    <el-input
                        type="number"
                        v-model="ruleForm.sealWidth"
                        placeholder="请输入印章宽度"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item prop="sealHeight" class="pass-form" label="印章高度">
                    <el-input
                        type="number"
                        v-model="ruleForm.sealHeight"
                        placeholder="请输入印章高称"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <div class="bottom-area" v-if="!isLogin">
              <div class="area-title">
                签署密码设置
                <span class="fz12 fc9 ml10">密码必须为6位数字</span>
              </div>
              <el-row>
                <el-col :span="24">
                  <el-form-item prop="pinCode" class="pass-form" label="签署密码">
                    <el-input
                        type="number"
                        :maxlength="6"
                        show-password
                        v-model="ruleForm.pinCode"
                        placeholder="请设置独立签署密码"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item
                      prop="pinCodeConfirm"
                      class="pass-form"
                      label="确认签署密码"
                  >
                    <el-input
                        type="number"
                        :maxlength="6"
                        show-password
                        v-model="ruleForm.pinCodeConfirm"
                        placeholder="请确认独立签署密码"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
            <el-form-item label-width="0">
              <el-button
                  class="next-button"
                  type="primary"
                  @click="submitForm('ruleForm')"
              >确认申领
              </el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>

    <el-dialog :close-on-click-modal="false"
               :close-on-press-escape="false"
               title="扫描二维码"
               :visible.sync="qrDialogVisible"
               width="350px"
               class="qr-dialog"
               @close="handleQrClose">
      <div ref="qrCodeUrl" class="qr-image">
        <template v-if="qrImg">
          <img :src="qrImg">
          <p>请打开微信扫描二维码，进行绘制签名</p>
        </template>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Cookies from "js-cookie";

export default {
  data() {
    var validPass = (rule, value, callback) => {
      let reg = /^\d{6}$/;
      if (value === "") {
        callback(new Error("请设置独立签署密码"));
      } else if (!reg.test(value)) {
        callback(new Error("密码必须为6位数字"));
      } else {
        callback();
      }
    };
    var validPassCon = (rule, value, callback) => {
      if (value === "" || value === undefined) {
        callback(new Error("请输入确认独立签署密码"));
      } else if (value !== this.ruleForm.pinCode) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      qrImg: null,
      qrDialogVisible: false,
      ruleForm: {
        pinCode: undefined,
        pinCodeConfirm: undefined,
        sealWidth: undefined,
        sealHeight: undefined,
      },
      rules: {
        sealName: [{required: true, message: "请输入印章名称", trigger: "blur"}],
        sealWidth: [{required: true, message: "请输入印章宽度", trigger: "blur"}],
        sealHeight: [{required: true, message: "请输入印章高度", trigger: "blur"}],
        pinCode: [{required: true, validator: validPass, trigger: "blur"}],
        pinCodeConfirm: [{required: true, validator: validPassCon, trigger: "blur"}],
      },
      personImg: "",
      userId: "",
    };
  },
  watch: {
    'ruleForm.sealWidth': {
      handler: function (newVal) {
        this.$set(this.ruleForm, 'sealHeight', newVal * this.ruleForm.personalImgHeight / this.ruleForm.personalImgWidth)
      },
      // 如果需要在路由变化时立即响应，可以设置immediate为true
      immediate: true,
    },
    'ruleForm.sealHeight': {
      handler: function (newVal) {
        this.$set(this.ruleForm, 'sealWidth', newVal * this.ruleForm.personalImgWidth / this.ruleForm.personalImgHeight)
      },
      // 如果需要在路由变化时立即响应，可以设置immediate为true
      immediate: true,
    },
  },
  computed: {
    user() {
      return this.$store.state.account.user
    },
    isLogin() {
      return this.user && this.user.userId
    }
  },
  mounted() {
    this.userId = this.$auth.getUserId() || this.user.userId
    this.getImg();
  },
  methods: {
    handleDelImg() {
      this.qrImg = undefined
      this.getImg();
    },
    handleQrClose() {
      if (this.timer) {
        clearTimeout(this.timer)
      }
    },
    getHandPad() {
      if (this.loading) return
      this.loading = true

      this.$http.post('/online/apply/personal/handPad', {
        userId: this.userId,
      }).then((res) => {
        if (res.data.code === 200) {
          this.qrDialogVisible = true;
          this.qrImg = 'data:image/png;base64,' + res.data.data
          this.timer = setTimeout(() => {//定时器
            this.trackComparison();
          }, 3000)
        } else {
          this.$message.error(res.data.msg || '获取手写板二维码失败')
        }
        this.loading = false
      }).catch(() => {
        this.$message.error('获取手写板二维码失败')
        this.loading = false
      })
    },
    //二维码回调函数
    trackComparison() {
      if (this.timer) {
        clearTimeout(this.timer)
      }

      this.$http.post('/online/apply/personal/sealImg/preview', {
        userId: this.userId,
      }).then((res) => {
        if (res.data.code === 200) {
          if (res.data.data && res.data.data.personalImg) {
            this.qrDialogVisible = false;
            this.personImg = 'data:image/png;base64,' + res.data.data.personalImg
          } else {
            //定时器
            this.timer = setTimeout(() => {
              this.trackComparison();
            }, 3000)
          }
        }
      }).catch(() => {

      })
    },
    getImg() {
      this.$http.post(this.$api.user.genSealImg, {
        userId: this.userId
      }, {'Content-Type': 'application/x-www-form-urlencoded'}).then(res => {
        if (res.data.code == 200) {
          this.personImg = "data:image/png;base64," + res.data.data.personalImg;
          this.$set(this.ruleForm, 'sealWidth', res.data.data.personalImgWidth)
          this.$set(this.ruleForm, 'sealHeight', res.data.data.personalImgHeight)
          this.ruleForm.personalImgHeight = res.data.data.personalImgHeight
          this.ruleForm.personalImgWidth = res.data.data.personalImgWidth
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    submitForm() {
      this.$refs.ruleForm.validate(async (value) => {
        if (value) {
          Cookies.set('seal', JSON.stringify(this.ruleForm))
          if (this.isLogin) {
            this.$router.push({path: "/register/orderPay"});
            return;
          }
          let params = {
            userId: this.userId,
            pinCode: this.ruleForm.pinCode,
          };
          this.loading = true;
          this.$http.post(this.$api.register.setPersonalPin, params).then((res) => {
            this.loading = false;
            if (res.data.code == 200) {
              this.$router.push({path: "/register/orderPay"});
            } else {
              this.$message.error(res.data.msg);
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.qr-image {
  text-align: center;
}

.qr-image > img {
  height: 250px;
}

.qr-image > p {
  margin: 0;
  padding-bottom: 40px;
}

::v-deep .qr-dialog .el-dialog__body {
  padding: 0;
}

::v-deep .el-card {
  width: 1200px;
  height: 730px;
}

::v-deep .el-card__header {
  display: flex;
  align-items: center;
  justify-content: center;
  // margin-bottom: 20px;
}

.img-del-btn {
  position: absolute;
  left: 50%;
  top: 50%;
  margin-top: -20px;
  margin-left: -20px;
}

.content {
  margin-left: 75px !important;
  margin-right: 75px !important;

  .top-area {
    .seal-confirm {
      display: flex;
      align-items: flex-start;
      padding: 20px 0;

      .confirm-text {
        width: 100px !important;
        text-align: right;
      }

      .image-div {
        width: 300px;
        border: 1px solid #dfe4ed;
        background: #f5f7fa;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding-top: 10px;
      }

      .image-seal {
        width: 300px;
        height: 150px;
        margin-top: 10px;
        overflow: hidden;
        position: relative;
      }

      .image-seal > img {
        width: 100%;
      }
    }
  }

  .bottom-area {
    padding-top: 20px;
    border-top: 1px solid #eee;
  }
}

.area-title {
  margin: 10px 0;
  padding-left: 14px;
  position: relative;
  font-size: 18px;
  text-align: left;

  &:after {
    content: "";
    position: absolute;
    width: 4px;
    height: 18px;
    background: #1d76f9;
    left: 0;
    bottom: 50%;
    transform: translateY(50%);
  }
}

.next-button {
  width: 350px;
  font-size: 16px;
  padding: 11px 20px !important;
  margin-top: 40px;
  box-shadow: 0 2px 4px 0 rgba(64, 129, 255, 0.4);
}

::v-deep .el-form {
  padding: 20px 0;
}

.pass-form {
  ::v-deep .el-form-item__content {
    width: 370px;
  }
}

//去掉number输入框的上下箭头
::v-deep input::-webkit-outer-spin-button {
  -webkit-appearance: none;
}

::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}

::v-deep input[type="number"] {
  -moz-appearance: textfield;
}

// 解决input number框输入中文后光标上移的问题
::v-deep .el-input__inner {
  line-height: 1px !important;
}
</style>
